import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ITreeOption } from '@/types';
import { IMenuItemInfo } from '@models/folders/IMenuItemInfo';

export class FoldersService {
    static async tasks(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/tasks/submenu/${submenu}`);
    }
    static async documents(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/documents/submenu/${submenu}`);
    }
    static async dictionaries(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/dictionaries/submenu/${submenu}`);
    }
    static async reports(submenu: string): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>(`/folders/reports/submenu/${submenu}`);
    }
    static async root(): Promise<AxiosResponse<ITreeOption[]>> {
        return $api.get<ITreeOption[]>('/folders/root');
    }

    static async fetchDocumentsInfo(name: string, submenu: string): Promise<AxiosResponse<IMenuItemInfo, any>> {
        return $api.get<IMenuItemInfo>(`/folders/documents/info/${name}/submenu/${submenu}`);
    }
    static async fetchTasksInfo(name: string, submenu: string): Promise<AxiosResponse<IMenuItemInfo, any>> {
        return $api.get<IMenuItemInfo>(`/folders/tasks/info/${name}/submenu/${submenu}`);
    }
}
